module.exports = "<div class=\"mb\"\n     base\n     ng-transclude\n     ng-style=\"{'transform': vm.translateY, 'height': vm.height || '100vh', 'transition': vm.transition}\"\n     ng-class=\"[vm.config.theme, { 'mobiage-base-topage-enter' : vm.topage }]\">\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/base/templates/base.template.html
// module id = 198
// module chunks = 0